<template>
    <div class="layout__width-100">
        <div class="text__align-center text__colour-white layout__margin__bottom-25px colour__background__grey-f7f8fa">
            <div class="layout__padding-clear layout__width-80 layout__padding-40px-0">
                <div class="text__colour-teal text__size-50 text__style-bold-700">Printed Products</div>
            </div>
        </div>


        <div class="layout__overflow-hidden layout__margin-20-0">


            <div class="layout__width-90 layout__padding-clear">

                <div class="component__product__card">
                    <router-link class="link__colour-black" to="/products/print/banners-and-display-boards">
                        <div class="component__product__card-body">
                            <div class="component__product__card-overlay"></div>
                            <img class="layout__width-100" src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/print/Bannerroll.jpg">
                            <div class="component__product__card-subtitle-text">Banners & Display Boards</div>
                            <div class="component__product__card-overlay-text">Establishing a powerful presence</div>
                        </div>
                    </router-link>
                </div>


                <div class="component__product__card">
                    <router-link class="link__colour-black" to="/products/print/brochures">
                        <div class="component__product__card-body">
                            <div class="component__product__card-overlay"></div>
                            <img class="layout__width-100"
                                 src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/print/propertybrochure.jpg">
                            <div class="component__product__card-subtitle-text">Brochures</div>
                            <div class="component__product__card-overlay-text">Showcase properties in their best light
                            </div>
                        </div>
                    </router-link>
                </div>

                <div class="component__product__card">
                    <router-link class="link__colour-black" to="/products/print/cards-and-invitations">
                        <div class="component__product__card-body">
                            <div class="component__product__card-overlay"></div>
                            <img class="layout__width-100"
                                 src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/print/newhomecard.jpg">
                            <div class="component__product__card-subtitle-text">Greetings Cards & Invitations</div>
                            <div class="component__product__card-overlay-text">Strengthen brand loyalty, build
                                relationships
                                and encourage referrals
                            </div>
                        </div>
                    </router-link>
                </div>

                <div class="component__product__card">
                    <router-link class="link__colour-black" to="/products/print/leaflets-and-flyers">
                        <div class="component__product__card-body">
                            <div class="component__product__card-overlay"></div>
                            <img class="layout__width-100"
                                 src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/print/flyers.jpg">
                            <div class="component__product__card-subtitle-text">Leaflets & Flyers</div>
                            <div class="component__product__card-overlay-text">Affordable and effective</div>
                        </div>
                    </router-link>
                </div>

                <div class="component__product__card">
                    <router-link class="link__colour-black" to="/products/print/stationery">
                        <div class="component__product__card-body">
                            <div class="component__product__card-overlay"></div>
                            <img class="layout__width-100"
                                 src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/print/stationeryset.jpg">
                            <div class="component__product__card-subtitle-text">Stationery</div>
                            <div class="component__product__card-overlay-text">We’re a one stop shop for all your
                                branded
                                stationery
                            </div>
                        </div>
                    </router-link>
                </div>


                <div class="component__product__card">
                    <router-link class="link__colour-black" to="/products/print/window-cards-and-posters">
                        <div class="component__product__card-body">
                            <div class="component__product__card-overlay"></div>
                            <img class="layout__width-100"
                                 src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/print/windowcards.jpg">
                            <div class="component__product__card-subtitle-text">Window Cards & Posters</div>
                            <div class="component__product__card-overlay-text">First impressions are everything</div>
                        </div>
                    </router-link>
                </div>
            </div>

        </div>
    </div>

</template>

<script>

    export default {
        name: "Digital",
        components: {},
        data() {
            return {}
        },
        created() {
        },
        methods: {}
    };
</script>